import { useState } from 'react';
import { window } from '../globals';
import useOnMount from './useOnMount';

/* To learn more about this data model, login to StatusPage.io using
 * the credentials in 1Password. In there you're going to find
 * documentation about how to build your own component.
 */

export enum Impact {
  NONE = 'none',
  MINOR = 'minor',
  MAJOR = 'major',
  CRITICAL = 'critical',
}

export const INDICATORS_TO_SHOW = new Set<Impact>([
  Impact.MAJOR,
  Impact.CRITICAL,
]);

export type Incident = {
  id: string;
  impact: Impact;
  name: string;
  shortlink: string;
  status: 'investigating' | 'identified' | 'monitoring' | 'resolved';
};

export type StatusIndicator = {
  indicator: Impact;
};

export type StatusPageData = {
  status: StatusIndicator;
  incidents: Incident[];
};

/**
 * Use this hook to track incident status from StatusPage.io.
 */
export default function useIncidentStatus() {
  const [shouldShow, setShouldShow] = useState<boolean>(false);
  const [incidents, setIncidents] = useState<Incident[]>([]);

  const setData = (data: StatusPageData) => {
    setIncidents(data.incidents);

    const { indicator } = data.status;
    setShouldShow(INDICATORS_TO_SHOW.has(indicator));
  };

  useOnMount(() => {
    if (!window.StatusPage) {
      return;
    }

    // eslint-disable-next-line new-cap
    const page = new window.StatusPage.page({ page: 'rtl9cj1jksdd' });
    page.summary({ success: setData });

    // window.setData = setData;
    // Test example: uncomment above line and run this from your browser console
    // setData({status: { indicator: 'major' }, incidents: [{id:'9bf13mmcy731', impact: 'alert-error', name: 'Something Important', shortlink: 'https://google.com'}]})
  });

  return {
    incidents,
    shouldShow,
  };
}
